exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-scrollbar{width:4px;height:7px}::-webkit-scrollbar-track{background:#ffffff}::-webkit-scrollbar-thumb{background:#000;border-radius:5px}::-webkit-scrollbar-thumb:hover{background:#000}\n", ""]);

// exports
